module.exports = __webpack_public_path__ + "img/flower.c55287ab.svg";